import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';

export interface ComplianceEventRow {
  id: string;
  driver_id: string;
  event_type: string;
  detail: Record<string, unknown> | null;
  session_id: string | null;
  occurred_at: string;
}

/**
 * Violations recorded by the mobile enforcement (dygnsvila expired, 13h cap,
 * rast warnings) — live via realtime the moment the phone writes them.
 */
export function useComplianceEvents(driverId: string | undefined, days = 7) {
  const [events, setEvents] = useState<ComplianceEventRow[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const since = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
    const { data } = await supabase
      .from('compliance_events')
      .select('*')
      .eq('driver_id', driverId)
      .gte('occurred_at', since)
      .order('occurred_at', { ascending: false })
      .limit(50);
    setEvents((data ?? []) as ComplianceEventRow[]);
    setLoading(false);
  }, [driverId, days]);

  useEffect(() => {
    if (!driverId) { setLoading(false); return; }
    refetch();
    const unsub = subscribeTable('compliance_events', refetch, `driver_id=eq.${driverId}`);
    return unsub;
  }, [driverId, refetch]);

  return { events, loading, refetch };
}
